import Badge from '@mui/material/Badge';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { UseBreakpoints } from '@my2n/use-breakpoints';
import { FormattedMessage } from 'react-intl';
import { getTooltipMessages } from './helper';

const styles = {
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'success.main',
      zIndex: 'auto',
    },
    cursor: 'pointer',
  },
  freeWithAUTooltip: {
    backgroundColor: 'transparent',
    maxWidth: '200px',
  },
  tooltip: {
    backgroundColor: 'transparent',
    maxWidth: '160px',
  },
};

interface IApartmentFreeTooltip {
  children: JSX.Element;
  count: number;
  isFreeApartmentWithIntercom?: boolean;
  isFreeApartmentWithAnsweringUnit?: boolean;
}

function ApartmentFreeTooltip({
  children,
  count,
  isFreeApartmentWithAnsweringUnit,
  isFreeApartmentWithIntercom,
}: IApartmentFreeTooltip) {
  const { upMd } = UseBreakpoints();
  const tooltipMessage = getTooltipMessages(isFreeApartmentWithIntercom, isFreeApartmentWithAnsweringUnit);

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: isFreeApartmentWithAnsweringUnit ? styles.freeWithAUTooltip : styles.tooltip,
        },
      }}
      placement={upMd ? 'right-start' : 'bottom-end'}
      title={
        <Paper sx={{ p: 1 }}>
          <Typography color="primary" fontWeight="bold" variant="body2">
            <FormattedMessage {...tooltipMessage.title} />
          </Typography>
          <Typography color="secondary" variant="caption">
            <FormattedMessage {...tooltipMessage.description} />
          </Typography>
        </Paper>
      }
    >
      <Badge sx={styles.badge} variant="dot">
        <Typography color={count > 0 ? 'text.primary' : 'text.disabled'} component="div" noWrap variant="body2">
          {children}
        </Typography>
      </Badge>
    </Tooltip>
  );
}

export default ApartmentFreeTooltip;
